/**
 * Context shared by every screen nested under a bot, from either entry point.
 * `scope` records which nav branch the user arrived through (§7.1); it never
 * decides a permission — that is always `caps`, from the server (§7.4 rule 1).
 */

import { useOutletContext } from 'react-router-dom';
import type { Bot, Rental } from '../api/types';
import type { CapabilityResolver } from '../hooks/useCapabilities';

export interface BotOutlet {
  bot: Bot;
  caps: CapabilityResolver;
  reload: () => void;
  scope: 'owner' | 'renter';
  /** The rental this screen is being viewed through, when scope is `renter`. */
  rental: Rental | null;
}

export function useBotOutlet(): BotOutlet {
  return useOutletContext<BotOutlet>();
}
